/**
 * 素材库主控制器
 */
'use strict';
angular
    .module('resourceCenterMaterialModule', [
        'resourceCenterMediaResourceLeftModule',
        'previewRouterModule', // 详情页路由
        'newFileModule',
    ])
    .controller('resCenterMRRelCtrl', [
        '$scope',
        'mrApiService',
        '$q',
        '$state',
        'messagePublishService',
        'localStorageService',
        'trsspliceString',
        'modalDialog',
        '$timeout',
        'mediaTagApiService',
        'mrService',
        'materialConst',
        'publicToolService',
        'mrApiService',
        function(
            $scope,
            apiService,
            $q,
            $state,
            messagePublishService,
            localStorageService,
            trsspliceString,
            modalDialog,
            $timeout,
            mediaTagApiService,
            mrService,
            materialConst,
            publicToolService,
            mrApiService
        ) {
            initStatus();
            initCheckCensorOpen();
            getAudioVideoInfo();
            setDropLisenier();

            /**
             * [initCheckCensorOpen 获取三鉴开关状态]
             *
             * @return  {[type]}  [return description]
             */
            function initCheckCensorOpen() {
                mrApiService
                        .isCheckCensorOpen()
                        .then((data) => {
                            $scope.isCheckCensorOpen = data.datas === 1;
                        });
            }

            /**
             * [initStatus 初始化通用状态]
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    ITEMCOUNT: 0,
                    FOLDERITEMCOUNT: 0,
                    CURRPAGE: 1,
                    PAGESIZE: 8,
                    PAGECOUNT: 1,
                };
                // 分类标签分页参数
                $scope.labelPage = {
                    ITEMCOUNT: 0,
                    CURRPAGE: 1,
                    PAGESIZE: 24,
                    PAGECOUNT: 1,
                };
            
                // 主控制器data数据
                $scope.basicalData = {
                    articleClassArr: [],
                };
                // 主控制器status状态
                $scope.basicalStatus = angular.extend({
                    buttonCheck: {
                        ModalName: '个人素材库',
                        name: 'personalmaterial',
                        type: {
                            '0': 'pics',
                            '1': 'audios',
                            '2': 'videos',
                            '3': 'words'
                        },
                    },
                    ispersonalmaterial: false, // 判断是不是个人素材(顶部按钮个人素材有区别)
                    // 修改弹窗显示
                    showMessage: null,
                    // 类型
                    typeCheck: {
                        '0': '图片',
                        '1': '音频',
                        '2': '视频',
                    },
                    // 顶部按钮执行操作所需要的参数(测试用)
                    buttonsNeedParams: {
                        resourceType: $state.params.resourcetype, // 判断是素材类型(视频图片还是音频)
                        relationId: '5', // 关联id
                        fileId: '', // 文件夹对应的关联id
                        multipartFile: '', // 素材上传
                        resourceTitle: '', // 素材标题
                    },
                    copyCurrLabelPage: 1, // 用于分类标签分页
                    isShowOrder: false,
                    materialStatus: materialConst.allStatusMap,
                    isAI: false,
                    isPicSearch: false,
                    isLabelMaterial: false,
                    picSearchFile: null,
                    btnDisabledTip: '请先选择素材',
                    preStatus: 'default', // 缓存功能切换前的状态，default-默认，inFolder-文件夹内, picSearch-以图搜图
                    textCheckList: {},
                    allowPicSearch: true,
    
                }, mrService.getMediaBasicStatus());
                $scope.items = []; // 素材列表数据
                $scope.mockData = [];
                $scope.tagsData = {
                    tags: [], // 选中的标签列表
                    tagsList: [], // 搜索出的标签列表
                    searchTags: '', // 标签搜索关键字
                    selectedTag: {}, // 选中标签对象
                };
                $scope.selectedArray = [];
                $scope.currentItem = {};
                $scope.labelData = {
                    personLabel: [],
                    placeLabel: [],
                    eventLabel: [],
                }; // 分类标签数据
                $scope.labelStatus = getPlaintShowAllLabelStatus(); // 获取标签分类的显示隐藏状态
                $scope.isShowAllLabel = false; // 标签分类列表是否查看更多
                $scope.currentLabel = {}; // 当前标签
                // 分类标签列表数据请求参数
                $scope.labelParams = {
                    scope: '',
                    keyword: '',
                    pageNum: 1,
                    pageSize: 10,
                    type: '',
                    ids: '',
                };
                $scope.currentLabelType = ''; // 当前出于查看更多状态的标签分类
                $scope.isShowPicSearchResult = false; // 是否显示识图结果数量
                $scope.searchByPicParams = {
                    file: '',
                    mrType: '',
                    labelIds: '',
                    pageNum: 1,
                    pageSize: 8,
                    customEndTime: '',
                    customStartTime: '',
                };
                $scope.isCheckCensorOpen = false;
                
            }

            /**
             * [getAudioVideoInfo description] 获取音视频配置
             * @return  {[type]}  [return description]
             */
            function getAudioVideoInfo(){
                let resourceType = $scope.basicalStatus.buttonsNeedParams.resourceType * 1;
                if (resourceType === 1 || resourceType === 2){ // 音视频才请求
                    publicToolService.queryModeconfigurationOnly('editCenter.avUploader').then((config) => {
                        // 媒资库、素材库的音视频配置与采编中心是一致的，故不需要单独配置，直接获取采编配置即可
                        $scope.basicalStatus.audioVideoConfigInfo = config.avUploader.value;
                    });   
                }
            }

            /**
             * [initCategory 初始化分类]
             *
             * @return  {[type]}  [return description]
             */
            // function initCategory() {
            //     apiService.getThemeData().then(function(data) {
            //         $scope.basicalData.articleClassArr = data;
            //     });
            // }


            $scope.showAllLabels = function(type) {
                let map = {
                    person: 'isShowPersonLabelAll',
                    place: 'isShowPlaceLabelAll',
                    event: 'isShowEventLabelAll',
                };
                $scope.labelStatus = getPlaintShowAllLabelStatus();
                $scope.labelStatus[map[type]] = true;
                $scope.labelParams.pageNum = 1;
                $scope.currentLabelType = type;
                getLabels(type).then((data) => {
                    // $scope.labelPage.PAGECOUNT = parseInt(data.summary_info.total / data.summary_info.pageSize);
                    $scope.labelPage.ITEMCOUNT = data.summary_info.total;
                });
                $scope.isShowAllLabel = true;
            };

            $scope.queryAIdata = function() {
                getLabels('person');
                getLabels('place');
                getLabels('event');
            };

            /**
             * [getLabels 获取标签数据]
             *
             * @param {type} type [标签类型，person-人物；place-地点; event-事物]
             * @param {type} pageNum [当前页数]
             * @param {type} pageSize [每页数量]
             *
             * @return {type} undefined
             */
            function getLabels(type) {
                let deffer = $q.defer();
                $scope.labelParams.type = type;
                if (type === 'place' || type === 'event') {
                    $scope.labelPage.PAGESIZE = $scope.labelParams.pageSize = 70;
                } else {
                    $scope.labelPage.PAGESIZE = $scope.labelParams.pageSize = 40;
                }
                $scope.labelParams.keyword = $scope.basicalStatus.searchParams.name;
                mediaTagApiService.getTagList($scope.labelParams).then(function(data) {
                    if (data.code === '200') {
                        $scope.labelData[type + 'Label'] = data.datas;
                        deffer.resolve(data);
                    } else {
                        deffer.reject();
                    }
                });
                return deffer.promise;
            }

            $scope.backToLabelList = function() {
                $scope.labelStatus = getPlaintShowAllLabelStatus();
                $scope.labelParams.pageSize = $scope.labelPage.PAGESIZE = 10;
                $scope.labelPage.ITEMCOUNT = 0;
                $scope.isShowAllLabel = false;
                $scope.basicalStatus.isLabelMaterial = false;
            };

            /**
             * [getPlaintShowAllLabelStatus 获取标签数据]
             *
             *
             * @return {type} undefined
             */
            function getPlaintShowAllLabelStatus() {
                return {
                    isShowPersonLabelAll: false,
                    isShowPlaceLabelAll: false,
                    isShowEventLabelAll: false,
                };
            }


            /**
             * [requestData 数据请求]
             *
             * @return  {[type]}  [return description]
             */
            $scope.requestData = function() {
                // 请求逻辑分析
                // 1.不在文件夹内
                // 2.文件夹内
                // 3.以图搜图
                // 4.分类标签素材
                $scope.selectedArray = [];
                if ($scope.basicalStatus.isInFolder){
                    if ($scope.basicalStatus.isWithFilters) {
                        resourceSearchData();
                    } else {
                        $scope.getFolderMaterial();
                    }
                } else if ($scope.basicalStatus.isLabelMaterial) {
                    resourceSearchData();
                } else if ($scope.basicalStatus.isPicSearch) {
                    searchByPicSend();
                } else if ($scope.basicalStatus.isAI) {
                    if ($scope.isShowAllLabel) {
                        $scope.showAllLabels($scope.currentLabelType);
                    } else {
                        $scope.queryAIdata();
                    }
                } else if ($scope.basicalStatus.isWithFilters){
                    resourceSearchData();
                } else {
                    $scope.getIndexData();
                }
                
            };

            /**
             * [resourceSearchData 从海贝检索数据]
             *
             * @return  {[type]}  [return description]
             */
            function resourceSearchData(){
                let deffered = $q.defer();
                clearPageData();
                $scope.loadingPromise = apiService
                    .getMaterialData(angular.extend({}, $scope.basicalStatus.commonParams, $scope.basicalStatus.searchParams, $scope.basicalStatus.orderParams))
                    .then(
                        function(data) {
                            if (data.code === '200') {
                                $scope.items = data.datas;
                                transferPage(data.summary_info);
                                deffered.resolve(data);
                            } else {
                                $scope.items = $scope.mockData;
                                modalDialog.alertType(data.code, '请求数据失败', 'error', false);
                                deffered.reject(data);
                            }
                            dealLocalStorage();
                        },
                        function(data) {
                            $scope.items = $scope.mockData;
                            dealLocalStorage();
                            modalDialog.alertType(data.code, data.msg, 'error', false);
                            deffered.reject(data);
                        }
                    );
                return deffered.promise;
            }

            /**
             * [transferPage 将媒资库分页数据转换为分页组件数据格式]
             *
             * @param   {[type]}  pageInfo  [pageInfo description]
             *
             * @return  {[type]}            [return description]
             */
            function transferPage(pageInfo) {
                $scope.page.ITEMCOUNT = pageInfo.total;
                $scope.page.PAGECOUNT = Math.ceil(pageInfo.total / pageInfo.pageSize);
            }

            /**
             * [pageChanged 翻页方法]
             *
             * @return  {[type]}  [return description]
             */
            $scope.pageChanged = function() {
                if ($scope.basicalStatus.isInFolder){
                    $scope.basicalStatus.folderSearchParams.pageNum = $scope.basicalStatus.searchParams.pageNum = $scope.basicalStatus.copyCurrPage = $scope.page.CURRPAGE;
                } else if ($scope.basicalStatus.isPicSearch) {
                    $scope.searchByPicParams.pageNum = $scope.basicalStatus.copyCurrPage = $scope.page.CURRPAGE;
                } else if ($scope.basicalStatus.isLabelMaterial) {
                    $scope.basicalStatus.searchParams.pageNum = $scope.basicalStatus.copyCurrPage = $scope.page.CURRPAGE;
                } else {
                    $scope.basicalStatus.indexParams.pageNum = $scope.basicalStatus.searchParams.pageNum = $scope.basicalStatus.copyCurrPage =
                    $scope.page.CURRPAGE;
                }
                $scope.requestData();
            };

            /**
             * [labelPageChanged 标签列表翻页方法]
             *
             * @return  {[type]}  [return description]
             */
            $scope.labelPageChanged = function() {
                $scope.labelParams.pageNum = $scope.basicalStatus.copyCurrLabelPage = $scope.labelPage.CURRPAGE;
                getLabels($scope.currentLabelType);
            };

            /**
             * [jumpToPage 跳转到指定页]
             *
             * @return  {[type]}  [return description]
             */
            $scope.jumpToPage = function() {
                if ($scope.basicalStatus.isInFolder){
                    $scope.basicalStatus.folderSearchParams.pageNum = $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = $scope.basicalStatus.copyCurrPage;
                } else if ($scope.basicalStatus.isPicSearch) {
                    $scope.searchByPicParams.pageNum = $scope.page.CURRPAGE = $scope.basicalStatus.copyCurrPage;
                } else if ($scope.basicalStatus.isLabelMaterial) {
                    $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = $scope.basicalStatus.copyCurrPage;
                } else {
                    $scope.basicalStatus.indexParams.pageNum = $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = $scope.basicalStatus.copyCurrPage;
                }
                $scope.requestData();
            };

            /**
             * [jumpToPage 跳转到标签指定页]
             *
             * @return  {[type]}  [return description]
             */
            $scope.jumpToLabelPage = function() {
                $scope.labelParams.pageNum = $scope.labelPage.CURRPAGE = $scope.basicalStatus.copyCurrLabelPage;
                getLabels($scope.currentLabelType);
            };

            /**
             * [jumpToPage 全选]
             *
             * @return  {[type]}  [return description]
             */
            $scope.selectAll = function() {
                if ($scope.selectedArray.length !== $scope.items.length) {
                    $scope.selectedArray = angular.copy($scope.items);
                    messagePublishService.publish('materialResourceSelectAll', true, true);
                } else {
                    $scope.selectedArray = [];
                    messagePublishService.publish('materialResourceSelectAll', false, true);
                }
            };

            /**
             * [dealLocalStorage description]处理localStorage参数，将素材id存进缓存
             *
             * @return  {[type]}  [return description]
             */
            function dealLocalStorage() {
                let relationIds = [];
                $scope.items.forEach((item) => {
                    if (item.relationtype !== 0) {
                        relationIds.push(item.relationid);
                    }
                });
                localStorageService.set('relationIds', relationIds);
            }

            /**
             * [sortData 数据排序]
             * @param   {[String]} type 排序类型
             * @return  {[Array]}  [return 排序数据]
             */
            $scope.sortData = function(type) {
                if ($scope.basicalStatus.orderParams.sortBy === type) {
                    $scope.basicalStatus.orderParams.sortOrder = $scope.basicalStatus.orderParams.sortOrder === 'desc' ? 'asc' : 'desc';
                } else {
                    
                    $scope.basicalStatus.orderParams.sortBy = $scope.basicalStatus.orderParams.sortBy === 'time' ? 'name' : 'time';
                }
                $scope.basicalStatus.isShowOrder = false;
                $scope.requestData();
            };

            $scope.swithOrderdisplay = function () {
                $scope.status.isShowOrder = !$scope.status.isShowOrder;
                $(document).on('click', function(e) {
                    var target = e.target || e.srcElement;
                    var select = document.getElementsByClassName('resource_sort_switch')[0];
                    if (target !== select && $scope.status.isShowOrder) {
                        $scope.status.isShowOrder = false;
                        $scope.$apply();
                    }
                });
            };

            /**
             * [getIndexData 从mysql获取数据]
             *
             * @return  {[type]}  [return description]
             */
            $scope.getIndexData = function() {
                clearPageData();
                sendDirectSearchRequest();
            };

            /**
             * [sendDirectSearchRequest 直接从Mysql请求数据]
             *
             * @return  {[type]}  [return description]
             */
            function sendDirectSearchRequest() {
                let deffered = $q.defer();
                $scope.loadingPromise = apiService
                    .getMaterialIndexData(angular.extend({}, $scope.basicalStatus.commonParams, $scope.basicalStatus.indexParams, $scope.basicalStatus.orderParams))
                    .then(
                        function(data) {
                            $scope.items = data.datas;
                            transferPage(data.summary_info);
                            dealLocalStorage();
                            deffered.resolve(data);
                        },
                        function(data) {
                            $scope.items = $scope.mockData;
                            dealLocalStorage();
                            deffered.reject(data);
                        }
                    );
                return deffered.promise;
            }

            /**
             * [loadTags description] 选择标签输入框回调函数
             * @param   {[type]}  val  [val description] 输入值
             * @return  {[type]}       [return description]
             */
            $scope.loadTags = function(val) {
                if (!val) {
                    $scope.tagsData.tagsList = [];
                    return;
                }
                apiService.getMark({ mark: val }).then(function(data) {
                    $scope.tagsData.tagsList = data.datas;
                });
            };
            

            /**
             * [loadTips description] 加载标签（智能标签）
             *
             * @param   {[type]}  word  [word description]
             *
             * @return  {[type]}        [return description]
             */
            $scope.loadTips = function(word) {
                mrService.loadTips($scope, word, '').then(function(data){
                    $scope.tagsData.tagsList = data;
                });
            };

            /**
             * [searchByTags 按标签检索]
             *
             * @return  {[type]}        [return description]
             */
            $scope.searchByTags = function() {
                if (!$scope.basicalStatus.isWithFilters){
                    $scope.basicalStatus.searchParams.pageNum = $scope.page.CURRPAGE = 1;
                }
                if ($scope.basicalStatus.commonParams.mainResourceType === '0') {
                    if ($scope.basicalStatus.isAI){
                        $scope.labelParams.ids = trsspliceString.spliceString($scope.tagsData.tags, 'id', ';');
                    }
                    $scope.basicalStatus.searchParams.mark = trsspliceString.spliceString($scope.tagsData.tags, 'id', ';');
                } else {
                    $scope.basicalStatus.searchParams.mark = trsspliceString.spliceString($scope.tagsData.tags, 'text', ';');
                }
                $scope.basicalStatus.isWithFilters = !!$scope.tagsData.tags.length;
                if (!$scope.basicalStatus.isWithFilters){
                    $scope.page.CURRPAGE = $scope.basicalStatus.folderSearchParams.pageNum = $scope.basicalStatus.copyCurrPage;
                }
                $scope.requestData();
            };

            /**
             * [searchBytags description] 关闭文件夹，返回上一级
             * @return  {[type]}  [return description]
             */
            $scope.closeFolder = function() {
                $scope.basicalStatus.searchParams = localStorageService.get('materialSearchParams');
                $scope.page.CURRPAGE = $scope.basicalStatus.searchParams.pageNum;
                $scope.basicalStatus.searchParams.fileId = 0;
                $scope.basicalStatus.isInFolder = false;
                $scope.basicalStatus.currentFolderId = 0;
                $scope.tagsData.tags = [];
                $scope.isWithFilters = false;
                $scope.requestData();
            };

            /**
             * [getFolderMaterial 获取文件夹内的素材]
             *
             * @param   {[type]}  fileId  [fileId description]
             *
             * @return  {[type]}          [return description]
             */
            $scope.getFolderMaterial = function() {
                setFolderSearchParam();
                clearPageData();
                sendFolderSearchRequest();
            };

            /**
             * [setFolderSearchParam 设置文件夹内容检索参数]
             *
             * @return  {[type]}  [return description]
             */
            function setFolderSearchParam(){
                $scope.basicalStatus.folderSearchParams.relationId = $scope.basicalStatus.currentFolderId;
                $scope.basicalStatus.folderSearchParams.sortBy = $scope.basicalStatus.orderParams.sortBy;
                $scope.basicalStatus.folderSearchParams.sortOrder = $scope.basicalStatus.orderParams.sortOrder;
                if ($scope.basicalStatus.searchParams.fileId === 0){
                    $scope.page.CURRPAGE = 1;
                }
                $scope.basicalStatus.searchParams = apiService.resetSearchparams();
                $scope.basicalStatus.searchParams.fileId = $scope.basicalStatus.currentFolderId;
            }

            /**
             * [sendFolderSearchRequest 文件夹内容检索请求]
             *
             * @return  {[type]}  [return description]
             */
            function sendFolderSearchRequest() {
                let params = angular.extend({}, $scope.basicalStatus.commonParams, $scope.basicalStatus.folderSearchParams);
                $scope.loadingPromise = apiService.getFolderMaterialData(params).then(
                    function(data) {
                        if (data.code === '200') {
                            $scope.items = data.datas; 
                            transferPage(data.summary_info);
                        } else {
                            modalDialog.alertType(data.code, data.msg, 'error', false);
                            $scope.items = $scope.mockData;
                            $scope.page.ITEMCOUNT = 0;
                        }
                        dealLocalStorage();
                    },
                    function(data) {
                        modalDialog.alertType(data.code, data.msg, 'error', false);
                        $scope.items = $scope.mockData;
                        $scope.page.ITEMCOUNT = 0;
                    }
                );
            }

            /**
             * [showLabelMaterial 请求分类标签关联的素材]
             *
             * @param   {[type]}  label  [label description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.showLabelMaterial = function(label) {
                $scope.currentLabel = label;
                $scope.page.CURRPAGE = 1;
                $scope.basicalStatus.searchParams = apiService.resetSearchparams();
                queryLabelMaterial();
            };

            /**
             * [queryLabelMaterial 获取分类标签关联的素材]
             *
             * @return  {[type]}  [return description]
             */
            function queryLabelMaterial(){
                $scope.basicalStatus.searchParams.mark = $scope.currentLabel.id;
                $scope.basicalStatus.searchParams.isPureMaterial = 2;
                $scope.basicalStatus.isLabelMaterial = true;
                $scope.requestData();
            }

            /**
             * [searchByPic 触发以图搜图]
             *
             * @param   {[type]}  e  [e description]
             *
             * @return  {[type]}     [return description]
             */
            $scope.searchByPic = function(e) {
                $('.hideFileInput').click();
                $('.hideFileInput').on('change', fileSelected);
            };

            /**
             * [setDropLisenier 监听拖拽上传区域]
             *
             * @return  {[type]}  [return description]
             */
            function setDropLisenier() {
                $(document).on({
                    dragleave: function(e) {
                        // 拖离
                        e.preventDefault();
                    },
                    drop: function(e) {
                        // 拖后放
                        e.preventDefault();
                    },
                    dragenter: function(e) {
                        // 拖进
                        e.preventDefault();
                    },
                    dragover: function(e) {
                        // 拖来拖去
                        e.preventDefault();
                    },
                });

                var oDrag = document.getElementById('resourceMaterialList');
                oDrag.ondragover = function(e){
                    e.dataTransfer.effectAllowed = 'move';
                };
                oDrag.ondrop = function(e) {
                    // e.stopPropagation();
                    e.preventDefault();
                    var fileobj = e.dataTransfer.files[0];
                    setPicSearchPreview(fileobj);
                };
            }

            /**
             * [setPicSearchPreview 设置以图搜图预览图]
             *
             * @param   {[type]}  file  [file description]
             *
             * @return  {[type]}        [return description]
             */
            function setPicSearchPreview(file) {
                var _type = file.type;
                // 判断文件类型
                if (_type.indexOf('image') !== -1) {
                    // 文件大小控制 TODO
                    // 读取文件对象
                    var reader = new FileReader();
                    // 读为DataUrl,无返回值
                    reader.readAsDataURL(file);

                    // 当读取成功时触发，$scope.result为读取的文件数据
                    reader.onload = function() {
                        $scope.basicalStatus.isPicSearch = true;
                        $scope.basicalStatus.isLabelMaterial = false;
                        // 添加文件预览
                        $timeout(function(){
                            document.getElementById('picSearchPreview').src = reader.result;
                        }, 0);
                    };
                    // 无论成功与否都会触发
                    reader.onloadend = function() {
                        if (reader.error) {
                            modalDialog.alertType('错误', reader.error, 'error', false);
                        } else {
                            $scope.basicalStatus.picSearchFile = file;
                            $scope.page.CURRPAGE = 1;
                            $scope.status.isShowOrder = false;
                            searchByPicSend();
                        }
                    };
                } else {
                    modalDialog.alertType('错误的文件格式', '请上传图片', 'error', false);
                }
            }

            /**
             * [searchByPicSend 以图搜图请求]
             *
             * @param   {[type]}  file  [file description]
             *
             * @return  {[type]}        [return description]
             */
            function searchByPicSend() {
                $scope.searchByPicParams.file = $scope.basicalStatus.picSearchFile;
                $scope.searchByPicParams.mrType = $scope.basicalStatus.commonParams.mrType;
                $scope.searchByPicParams.labelIds = trsspliceString.spliceString($scope.tagsData.tags, 'id', ';');
                $scope.searchByPicParams.customStartTime = $scope.basicalStatus.searchParams.customStartTime;
                $scope.searchByPicParams.customEndTime = $scope.basicalStatus.searchParams.customEndTime;
                clearPageData();
                $scope.loadingPromise = apiService.searchByPic($scope.searchByPicParams).then(function(data) {
                    if (data.code === '200') {
                        $scope.items = data.datas;
                        transferPage(data.summary_info);
                        $scope.isShowPicSearchResult = true;
                    } else {
                        $scope.page.ITEMCOUNT = 0;
                    }
                }, function(){
                    $scope.page.ITEMCOUNT = 0;
                });
            }

            /**
             * [clearPageData 清除页面数据]
             *
             * @return  {[type]}  [return description]
             */
            function clearPageData(){
                $scope.items = [];
                $scope.selectedArray = [];
            }

            /**
             * [backFromPicSearch 从搜图结果返回]
             *
             * @return  {[type]}  [return description]
             */
            $scope.backFromPicSearch = function() {
                $scope.clearPicSearchFile();
                $scope.basicalStatus.isPicSearch = false;
                $scope.isShowPicSearchResult = false;
                if (!$scope.basicalStatus.isLabelMaterial) {
                    $scope.requestData();
                } else {
                    $scope.getLabels($scope.currentLabelType);
                }
            };

            /**
             * [fileSelected 以图搜图点击上传]
             *
             * @return  {[type]}  [return description]
             */
            function fileSelected() {
                var fbutton = $('.hideFileInput')[0]; // dom元素
                var file = fbutton.files[0];
                setPicSearchPreview(file);
            }

            /**
             * [clearPicSearchFile 清除以图搜图图片选择]
             *
             * @return  {[type]}  [return description]
             */
            $scope.clearPicSearchFile = function(){
                var fbutton = $('.hideFileInput')[0]; // dom元素
                fbutton.value = '';
            };
        },
    ]);
